/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useIntl } from 'react-intl-next';

import { cssMap, jsx } from '@atlaskit/css';
import Lozenge from '@atlaskit/lozenge';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';
import { type AgentAction } from '@atlassian/conversation-assistant-service';

import { getAgentActionIcon } from '../../../utils/agent-actions';

import messages from './messages';

const styles = cssMap({
	wrapper: {
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderColor: token('color.border'),
		borderRadius: token('border.radius.100', '0.25rem'),
		paddingTop: token('space.050'),
		paddingRight: token('space.050'),
		paddingBottom: token('space.050'),
		paddingLeft: token('space.050'),
		width: 'fit-content',
	},

	pillIcon: {
		borderRadius: token('border.radius.100', '0.25rem'),
		width: '20px',
		height: '20px',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
	},
});

export const AgentActionPill = ({ action: { name, id, tags } }: { action: AgentAction }) => {
	const { formatMessage } = useIntl();

	return (
		<Inline xcss={styles.wrapper} space="space.050" alignBlock="center">
			<Box xcss={styles.pillIcon} backgroundColor="color.background.brand.subtlest">
				{getAgentActionIcon(id)}
			</Box>
			<Text>
				{name}{' '}
				{tags.includes('beta') && (
					<Lozenge appearance="new">{formatMessage(messages.betaTag)}</Lozenge>
				)}
			</Text>
		</Inline>
	);
};
